// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".cmx-lifeline{min-width:400px}", "",{"version":3,"sources":["webpack://src/views/ui/lifeline.scss"],"names":[],"mappings":"AAAA,cACE,eAAA","sourcesContent":[".cmx-lifeline {\n  min-width: 400px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
